import { request } from './request'
// 获取任务列表
export interface GetTpList {
  limit: number
  page: number
  keyword?: string
  task_id?: string
  start_time?: string
  end_time?: string
  result_status?: number
  biz_area?: string
}
export const getTpList = (data: GetTpList) =>
  request('/portal/verify/tp/resultList', {
    params: {
      ...data,
    },
  })
// 获取攻击链防护
export const getKillChain = data =>
  request(`/portal/verify/tp/resultKillChainDefense`, {
    params: {
      ...data,
    },
  })
// 获取任务摘要、任务拦截
export const getRingPattern = data =>
  request(`/portal/verify/tp/resultRingPattern`, {
    params: {
      ...data,
    },
  })
// 获取危险等级分布
export const getResultRiskLevel = data =>
  request(`/portal/verify/tp/resultRiskLevel`, {
    params: {
      ...data,
    },
  })
// 获取攻击防护排名
export const getDefenseRankings = data =>
  request(`/portal/verify/tp/resultDefenseRankings`, {
    params: {
      ...data,
    },
  })
// 获取设备告警统计
export const getDeviceAlarmStat = data =>
  request(`/portal/verify/tp/resultSecurityDeviceChart`, {
    params: {
      ...data,
    },
  })
// 获取告警日志
export const getPluginLog = data =>
  request(`/portal/verify/tp/getPluginLog`, {
    params: {
      ...data,
    },
  })

export const getAreaData = () => request('/portal/verify/tp/jobBizAreaList', {})

//  删除列表
export interface DeleteList {
  result_id_list: string[]
}
export const deleteList = (data: DeleteList) =>
  request('/portal/verify/tp/batchDeleteResult', {
    method: 'delete',
    params: data,
  })
//  查看详情列表
export interface GetDetailList {
  result_id: number
  status: number
  level: number[]
  name?: string
}
export const getDetailList = (data: GetDetailList) =>
  request('/portal/verify/tp/result/detail/list', {
    method: 'post',
    data,
  })
//  查看详情基础数据
export interface GetDetailStd {
  result_id: string
  task_id: string
}
export const getDetailStd = (data: GetDetailStd) =>
  request('/portal/verify/tp/result/detail/std', {
    params: {
      ...data,
    },
  })

// 详情数据
export const getTaskInfo = (data: GetDetailStd) =>
  request('/portal/verify/tp/resultInfo', {
    params: {
      ...data,
    },
  })

export interface GetRequest {
  id: string
}
export const getRequest = (data: GetRequest) =>
  request('/portal/verify/tp/resultPluginDetail', {
    params: {
      ...data,
    },
  })

export const getPluginFilter = data =>
  request(`/portal/verify/tp/results/${data.resultId}/attack_type`)

export interface GetListDetailsElement {
  task_id: string
  result_id: string
  keyword?: string
  intercept_status_list?: string
  risk_level_list: string
  attack_type_list?: string
  kill_chain_list: string
  component_list?: string
  attck?: string
  sec_device?: string
  alert_log?: number
  page?: number
  limit?: number
  tag_ids?: string[]
}

export const getListDetailsElement = (data: GetListDetailsElement) =>
  request('/portal/verify/tp/resultResourceList', {
    params: {
      ...data,
    },
  })

//影响组件分布图
export const resultComponentChart = data =>
  request('/portal/verify/tp/resultComponentChart', {
    params: data,
  })

//安全设备数据
export const resultDeviceOption = data =>
  request('/portal/verify/tp/resultDeviceOption', {
    params: data,
  })

//ATT&CK 数据
export const detailAttCkList = data =>
  request('/portal/verify/tp/detailAttCkList', {
    params: data,
  })

//模板拦截成功率
export const resultTemplateDefenseRankings = data =>
  request('/portal/verify/tp/resultTemplateDefenseRankings', {
    params: data,
  })

//停止任务
export const stopTask = data =>
  request('/portal/verify/tp/stopTask', {
    method: 'post',
    data,
  })

// 任务复测
export const retestTask = data =>
  request('/portal/verify/tp/taskReExec', {
    method: 'post',
    data,
  })

// 详情树结构标签选项
export const getTagTreeOptions = data =>
  request(`/portal/verify/tp/result/tag_categories`, {
    params: {
      ...data,
    },
  })

// 获取离线日志导入信息
export const getOfflineLogImportInfo = id =>
  request(`/portal/v1/tp/results/${id}/get_log_device_import_records`)

// 删除日志设备导入记录
export const deleteOfflineLogImportRecord = data =>
  request(`/portal/v1/tp/results/${data.resultId}/log_device_import_record/${data.id}`, {
    method: 'delete',
    timeout: 60000,
  })

// 更新资源拦截状态
export const updateResourceInterceptStatus = data =>
  request(`/portal/verify/tp/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: data.list,
  })

// 下载pcap
export const downloadPcap = ({ resultId, resultPluginId }) =>
  request(`/portal/v1/tp/results/${resultId}/download_pcap_file/${resultPluginId}`, {
    method: 'get',
    responseType: 'blob',
    isComplete: true,
  })

// 获取主任务列表
export const getTaskList = data =>
  request('/portal/verify/tp/tasks', {
    params: {
      ...data,
    },
  })

// 获取任务执行列表
export const getTaskExecList = data =>
  request('/portal/verify/tp/task/executions', {
    params: {
      ...data,
    },
  })

// 获取分组列表 (筛选)
export const getGroupList = () => request('/portal/verify/tp/task_results/group_list')

// 删除主任务
export const deleteTask = (data: string[]) =>
  request('/portal/verify/tp/task', {
    method: 'post',
    data: { taskIds: data },
  })

// 获取任务详情
export const getTaskDetail = (taskId: string) => request(`/portal/verify/tp/task/detail/${taskId}`)

// 获取攻击路径列表 (筛选)
export const getAttackPathList = () => request('/portal/verify/tp/tasks/list_attack_path')

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/verify/tp/task_results/${data.resultId}/case`)

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/verify/tp/task_results/${data.resultId}/case/count`, {
    params: {
      ...data,
    },
  })

// 获取攻击路径
export const getAttackPathData = () => request('/portal/v1/tp/attack_paths_by_task')

// 获取任务基础信息
export const getTaskBaseInfo = (id: string) => request(`/portal/verify/tp/task/base/${id}`)

// 2.0.2
// 关联模板列表
export const getTaskDetailTemplateList = data =>
  request(`/portal/verify/tp/tasks/${data.taskId}/templateList`, { params: data })

// 关联模板用例列表
export const getTaskDetailCaseList = data =>
  request(`/portal/verify/tp/tasks/${data.taskId}/template/${data.templateId}/caseList`, {
    params: data,
  })

// 关联模板用例的攻击类型筛选
export const getTaskDetailCaseAttackType = data =>
  request(`/portal/common/attack/attack_type_filter_list`, {
    params: data,
  })

// 获取安全设备列表
export const getSecurityDeviceList = () => request('/portal/verify/tp/task/device_list')

// 2.0.2
// 获取筛选聚合
export const getResourceFilterData = data =>
  request(`/portal/verify/tp/result/${data.resultId}/filter_data`, {
    params: data,
  })

// 获取任务分数
export const getTaskScore = data => request(`/portal/verify/tp/result/${data.resultId}/score`)

// 用例分级分布
export const getCaseLevelDistribution = data =>
  request(`/portal/verify/tp/result/${data.resultId}/resource_level/distribution`)

// 获取风险等级分布
export const getRiskLevelDistribution = data =>
  request(`/portal/verify/tp/result/${data.resultId}/risk_level/distribution`)

// 用例状态分布
export const getUseCaseStatusDistribution = data =>
  request(`/portal/verify/tp/result/${data.resultId}/status/distribution`)

// 攻击防护排名
export const getAttackProtectionRanking = data =>
  request(`/portal/verify/tp/result/${data.resultId}/attack_protection_ranking`)

// 设备防护排名
export const getDeviceProtectionRanking = data =>
  request(`/portal/verify/tp/result/${data.resultId}/device_protection_ranking`)

// 模板防护排名
export const getTemplateProtectionRanking = data =>
  request(`/portal/verify/tp/result/${data.resultId}/template_protection_ranking`)

// 获取拦截状态
export const getInterceptStatus = data =>
  request(`/portal/verify/tp/result/${data.resultId}/intercept_status/distribution`)

/**
 * basthreat_protectionv1TaskBaseInfoReply
 */
export interface BaseInfo {
  agentToAgent?: TaskAgentToAgent
  /**
   * 链路 id
   */
  chainId?: string
  cronSchedule?: BasthreatProtectionv1TaskCronSchedule
  /**
   * 安全设备ID列表
   */
  deviceIds?: string[]
  /**
   * 执行次数上限
   */
  executeTimesLimit?: number
  /**
   * 任务分组
   */
  groupId?: string
  /**
   * 任务名称
   */
  name?: string
  /**
   * int64 attack_path_id = 6 ; // 攻击路径ID 弃用
   * repeated int64 template_ids = 7 ; // 模板列表 弃用，改用template_list代替
   * repeated int64 plugin_ids = 8 ; // 插件列表 弃用，pcap收集
   */
  pcapCollection?: boolean
  /**
   * 执行优先级
   */
  priority?: number
  reportConfig?: TaskReportConfig
  /**
   * 用例ID列表
   */
  resourceIds?: string[]
  taskKind?: BasthreatProtectionv1TaskKindDetail
  /**
   * 模板列表
   */
  templateList?: BasthreatProtectionv1TaskBaseInfoReplyTemplate[]
  [property: string]: any
}

/**
 * 验证信息
 */
export interface TaskAgentToAgent {
  /**
   * dnat
   */
  dNat?: string
  /**
   * 攻击目标
   */
  dstAgentId?: string
  /**
   * 攻击目标IP (可能存在多个 执行任务需要选择一个)
   */
  dstAgentIp?: string
  isNat?: boolean
  /**
   * 中间经过 IP
   */
  middleIps?: string[]
  /**
   * snat
   */
  sNat?: string
  /**
   * 攻击源
   */
  srcAgentId?: string
  /**
   * 攻击源IP (可能存在多个 执行任务需要选择一个)
   */
  srcAgentIp?: string
  [property: string]: any
}

/**
 * basthreat_protectionv1TaskCronSchedule
 */
export interface BasthreatProtectionv1TaskCronSchedule {
  /**
   * 每月的哪几天
   */
  dayOfMonth?: number[]
  /**
   * 周期时间，每周的哪几天
   */
  dayOfWeek?: number[]
  /**
   * 间隔N小时
   */
  intervalOfHour?: number
  /**
   * 间隔N分钟
   */
  intervalOfMinute?: number
  /**
   * (每日/每周/每月)当天的时间 hh:ii:ss
   */
  timeOfDay?: string
  [property: string]: any
}

/**
 * TaskReportConfig
 */
export interface TaskReportConfig {
  condition?: ReportConfigCondition
  /**
   * 邮箱
   */
  emailList?: TaskReportConfigEmail[]
  /**
   * 是否过滤
   */
  filter?: boolean
  /**
   * 是否发送
   */
  send?: boolean
  [property: string]: any
}

/**
 * - condition_anyway: 无条件
 * - condition_all_failed: 全部拦截失败
 * - condition_exist_failed: 存在拦截失败
 */
export enum ReportConfigCondition {
  ConditionAllFailed = 'condition_all_failed',
  ConditionAnyway = 'condition_anyway',
  ConditionExistFailed = 'condition_exist_failed',
}

/**
 * TaskReportConfigEmail
 */
export interface TaskReportConfigEmail {
  email?: string
  id?: string
  /**
   * 人员名称
   */
  name?: string
  [property: string]: any
}

/**
 * - TaskKindDetailImmediately: 立即任务
 * - TaskKindDetailBooking: 预定任务
 * - TaskKindDetailCycleDay: 周期任务 日
 * - TaskKindDetailCycleWeek: 周期任务 周
 * - TaskKindDetailCycleMonth: 周期任务 月
 */
export enum BasthreatProtectionv1TaskKindDetail {
  TaskKindDetailBooking = 'TaskKindDetailBooking',
  TaskKindDetailCycleDay = 'TaskKindDetailCycleDay',
  TaskKindDetailCycleMonth = 'TaskKindDetailCycleMonth',
  TaskKindDetailCycleWeek = 'TaskKindDetailCycleWeek',
  TaskKindDetailImmediately = 'TaskKindDetailImmediately',
  TaskKindDetailUnknown = 'TaskKindDetailUnknown',
}

/**
 * basthreat_protectionv1TaskBaseInfoReplyTemplate
 */
export interface BasthreatProtectionv1TaskBaseInfoReplyTemplate {
  /**
   * 模板ID
   */
  id?: string
  /**
   * 使用最新的用例
   */
  useLatestResource?: boolean
  [property: string]: any
}
